export default "__VITE_ASSET__53e06520__"